import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { Banner } from "@/types";


export default /*#__PURE__*/_defineComponent({
  props: {
    banner: null,
    quotes: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (__props.banner?.styles)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _createTextVNode(_toDisplayString(__props.quotes ? '"' : null), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.banner?.styles, (style, index) => {
          return (_openBlock(), _createElementBlock("span", {
            key: index,
            style: _normalizeStyle({ color: style.color || 'unset' })
          }, _toDisplayString(style.text), 5))
        }), 128)),
        _createTextVNode(_toDisplayString(__props.quotes ? '"' : null), 1)
      ]))
    : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.banner?.name), 1))
}
}

})